import { ImpactModule } from 'types'
import { ALERTS_OF_VULNERABILITY_PAGES } from './pages'
import { ALERTS_OF_VULNERABILITY_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const ALERTS_OF_VULNERABILITY_MODULE: ImpactModule = {
  NAME: 'alert',
  UPPER_NAME: 'ALERT',
  API_NAME: 'ALERT',
  NAME_PTBR: 'Alertas',
  PAGES: ALERTS_OF_VULNERABILITY_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: ALERTS_OF_VULNERABILITY_PAGES_ORDER_FOR_PERMISSIONS,
}
